export const STORAGE_KEYS = {
  THEME: 'engine:blog:theme',
  SEARCH_HISTORY: 'engine:blog:search-history',
  DETAIL_SIDEBAR_COLLAPSED: 'engine:blog:detail-sidebar-collapsed',
  ALBUM_LIST_LAYOUT: 'engine:blog:album-list-layout',
  ALBUM_DETAIL_LAYOUT: 'engine:blog:album-detail-layout',
  COMMENT_PROFILE: 'engine:blog:comment-profile',
  LIKE_CONTENT: 'engine:blog:liked-content',
  LIKE_ALBUM: 'engine:blog:liked-album',
  AUTH_TOKEN: 'engine:blog-auth:token',
  AUTH_USER_ID: 'engine:blog-auth:user-id',
  AUTH_EXPIRES_AT: 'engine:blog-auth:expires-at',
  AUTH_USER: 'engine:blog-auth:user'
}
